import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bottomsnap",
  "use": "icon-bottomsnap-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bottomsnap\"><path d=\"M896 800v48H128v-48h768zM848 368V752h-240V368h240zM464 224v480H272v-480h192m48-48H224V752H512V176z\" p-id=\"1965\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol